<template>
    <div style="height: 100%;">
        <el-card class="box-card" style="height: 100%;">
            <div slot="header" class="clearfix">
                <span>日志查看器测试页面</span>
            </div>
            
            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="form-unit">控制面板</div>
                    
                    <el-form :model="formModel" size="mini" label-width="100px">
                        <el-form-item label="日志类型">
                            <el-radio-group v-model="formModel.logType">
                                <el-radio label="string">字符串格式</el-radio>
                                <el-radio label="array">数组格式</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        
                        <el-form-item label="显示行号">
                            <el-switch v-model="formModel.hasNumber"></el-switch>
                        </el-form-item>
                        
                        <el-form-item label="自动滚动">
                            <el-switch v-model="formModel.autoScroll"></el-switch>
                        </el-form-item>
                        
                        <el-form-item label="测试内容">
                            <el-input 
                                v-model="formModel.testContent" 
                                type="textarea" 
                                :rows="8"
                                placeholder="请输入测试日志内容，支持换行">
                            </el-input>
                        </el-form-item>
                        
                        <el-form-item>
                            <el-button @click="addTestLog" type="primary">添加普通日志</el-button>
                            <el-button @click="clearLogs" type="warning">清空日志</el-button>
                        </el-form-item>
                        
                        <el-form-item label="日志类型测试">
                            <el-button @click="addSuccessLog" type="success" size="small">成功日志</el-button>
                            <el-button @click="addErrorLog" type="danger" size="small">错误日志</el-button>
                            <el-button @click="addWarnLog" type="warning" size="small">警告日志</el-button>
                            <el-button @click="addInfoLog" type="info" size="small">信息日志</el-button>
                        </el-form-item>
                        
                        <el-form-item label="特殊测试">
                            <el-button @click="addMultiLineLog" type="success" size="small">多行日志</el-button>
                            <el-button @click="addLongLineLog" type="info" size="small">长行日志</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
                
                <el-col :span="12">
                    <div class="form-unit">日志显示区域</div>
                    
                    <!-- 字符串格式日志显示 -->
                    <log-viewer 
                        v-if="formModel.logType === 'string'"
                        ref="stringLogViewer"
                        :log="stringLogs" 
                        :height="580" 
                        :hasNumber="formModel.hasNumber"
                        :autoScroll="formModel.autoScroll"
                        :loading="isLoading"
                        @update:log="stringLogs = $event"
                    />
                    
                    <!-- 数组格式日志显示 -->
                    <log-viewer 
                        v-else
                        ref="arrayLogViewer"
                        :logs="arrayLogs" 
                        :height="580" 
                        :hasNumber="formModel.hasNumber"
                        :autoScroll="formModel.autoScroll"
                        :loading="isLoading"
                        @clear-logs="arrayLogs = []"
                    />
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>

<script>
import LogViewer from '@/extends/x-log-viewer/components/XLogViewer.vue'

export default {
    name: "LogViewerTest",
    components: {
        LogViewer
    },
    data() {
        return {
            formModel: {
                logType: 'string',
                hasNumber: true,
                autoScroll: true,
                testContent: '这是一条测试日志\n支持换行显示\n可以测试自动滚动功能'
            },
            stringLogs: '',
            arrayLogs: [],
            isLoading: true
        }
    },
    methods: {
        // 获取当前日志组件引用
        getLogViewer() {
            const logViewer = this.formModel.logType === 'string' ? this.$refs.stringLogViewer : this.$refs.arrayLogViewer;
            if (!logViewer) {
                console.warn('日志组件引用未准备好');
                return null;
            }
            return logViewer;
        },
        
        addTestLog() {
            const timestamp = new Date().format('yyyy-MM-dd HH:mm:ss');
            const content = `[${timestamp}] ${this.formModel.testContent || '测试日志内容'}`;
            this.getLogViewer()?.info(content);
        },
        
        addSuccessLog() {
            const timestamp = new Date().format('yyyy-MM-dd HH:mm:ss');
            const content = `[${timestamp}] 操作成功完成`;
            this.getLogViewer()?.success(content);
        },
        
        addErrorLog() {
            const timestamp = new Date().format('yyyy-MM-dd HH:mm:ss');
            const content = `[${timestamp}] 发生错误，请检查配置`;
            this.getLogViewer()?.error(content);
        },
        
        addWarnLog() {
            const timestamp = new Date().format('yyyy-MM-dd HH:mm:ss');
            const content = `[${timestamp}] 警告：请注意相关设置`;
            this.getLogViewer()?.warn(content);
        },
        
        addInfoLog() {
            const timestamp = new Date().format('yyyy-MM-dd HH:mm:ss');
            const content = `[${timestamp}] 信息：系统运行正常`;
            this.getLogViewer()?.info(content);
        },
        
        clearLogs() {
            this.getLogViewer()?.clearLog();
        },
        
        addMultiLineLog() {
            const timestamp = new Date().format('yyyy-MM-dd HH:mm:ss');
            const multiLineContent = `[${timestamp}] 多行日志测试：
第一行：这是第一行内容
第二行：这是第二行内容，包含一些特殊字符 !@#$%^&*()
第三行：这是第三行内容，测试自动换行功能
第四行：这是第四行内容，测试长文本自动换行功能，这里有很多文字用来测试自动换行功能是否正常工作
第五行：结束`;
            
            this.getLogViewer()?.success(multiLineContent);
        },
        
        addLongLineLog() {
            const timestamp = new Date().format('yyyy-MM-dd HH:mm:ss');
            const longLineContent = `[${timestamp}] 这是一条非常长的日志行，用来测试自动换行功能。这条日志包含了很多文字，包括中文、英文、数字123456789、特殊符号!@#$%^&*()_+-=[]{}|;':\",./<>?，以及一些很长的单词likeThisVeryLongWordThatShouldBeWrappedAutomatically。这条日志的目的是测试当文本内容超过容器宽度时，是否能够正确地自动换行显示，而不会导致水平滚动条的出现。`;
            
            this.getLogViewer()?.warn(longLineContent);
        }
    },
    mounted() {
        // 添加一些初始日志
        this.$nextTick(() => {
            this.addTestLog();
            this.addMultiLineLog();
        });
    }
}
</script>

<style scoped>
.form-unit {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0 10px 0;
    color: #409EFF;
    border-bottom: 2px solid #409EFF;
    padding-bottom: 5px;
}

.box-card {
    height: 100%;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}
</style>
